/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CityInputs */

const de__field_city = /** @type {(inputs: _Field_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**

* @param {_Field_CityInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_city = /** @type {((inputs?: _Field_CityInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CityInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_city(inputs)
});